import React from 'react';
import Drawer from '@material-ui/core/Drawer';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import ListItemText from '@material-ui/core/ListItemText';
import { useTheme } from '@material-ui/core/styles';
import { Link, NavLink } from 'react-router-dom';
import { useMediaQuery, Zoom } from '@material-ui/core';
import generateStyles from './styles';
import { MenuProps } from './index.types';
import ExitToAppIcon from '@material-ui/icons/ExitToApp';
import ToolTip from '../../shared/ToolTip';
import { MenuItem, TextField} from '@material-ui/core';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';

const MenuItems: React.FC<any> = ({menuItems, classes, menuItemClickHandler}) => {
  return menuItems.map((menuItem: any) => (
    <NavLink to={menuItem.path} exact={menuItem.path === '/dashboard' || menuItem.path === '/dashboard/'} className={classes.linkText} activeClassName={classes.activeLink} key={menuItem.path}>
      <ListItem button onClick={menuItemClickHandler} className="bt">
        <ListItemIcon className={classes.listIcon}>{menuItem.icon}</ListItemIcon>
        <ListItemText className={classes.primary} primary={menuItem.text} />
      </ListItem>
    </NavLink>
  ));
}

export default function(props: MenuProps): React.ReactElement {
    const {drawerWidth, drawerOpen, menuItemClickHandler, menuItems, filterYear, handleFilterYearChange} = props;
    const theme = useTheme();
    const isSmallScreen = useMediaQuery(theme.breakpoints.down('sm'));

    const useStyles = generateStyles({drawerOpen, drawerWidth, isSmallScreen});
    
    const classes = useStyles();

    // const menuItems = [
    //   {
    //     text: "Configuration Process",
    //     url: "/configuration-process",
    //     icon: <InboxIcon />
    //   },
    //   {
    //     text: "Manage User",
    //     url: "/manage-user",
    //     icon: <MailIcon />
    //   }
    // ];

    return (
        <Drawer
        className={classes.drawer}
        variant="permanent"
        classes={{
          paper: classes.drawerPaper,
        }}
      >
        
        {/* <Toolbar /> */}
        <div className={classes.drawerContainer}>
        <TextField
              style={{width: 140, padding: '0 10px', borderRadius: 5 , margin:15}}
              className={classes.drop}
              InputProps={{disableUnderline: true}}
              // labelId="demo-simple-select-label"
              // label="Age"
              id="demo-simple-select"
              // onChange={handleChange}
              select
              SelectProps={{IconComponent:  (props) => <ExpandMoreIcon {...props}/>}}
              value={filterYear}
              onChange={handleFilterYearChange}
          >
              <MenuItem value={-1}>Select Financial year</MenuItem>
              <MenuItem value={2021}>2020 - 2021</MenuItem>
              </TextField>
          <List className={classes.menuContainer}>
              <MenuItems menuItems={menuItems} classes={classes} menuItemClickHandler={menuItemClickHandler}/>
          </List>
          <div className={classes.logoutContainer}>
            <Link to="/login">
              <ToolTip TransitionComponent={Zoom} enterDelay={0} title="Logout" arrow>
                  <ExitToAppIcon className={classes.logoutIcon}/>
              </ToolTip>
            </Link>
          </div>
        </div>
      </Drawer>
    );
};